import * as React from 'react';
import { createStyles, makeStyles, Theme, lighten, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import DeleteIcon from '@material-ui/icons/Delete';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { Button, IconButton, CssBaseline, FormControlLabel } from '@material-ui/core';
import Files from 'react-files';
import { DesignData, TatData, MaterialData, ManufacturerData, BranchData } from 'src/reducers/fileUpload';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import { green } from '@material-ui/core/colors';
import { UserDetail } from 'src/reducers/user';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
export interface FilesTableViewProps {
    files2: Array<File>;
    progress: Array<number>;
    sending: boolean;

    deleteRowbyId: () => void;
    onUploadAllFiles: () => void;
    onClearAllFiles: () => void;
    onClearAllUploaded: () => void;
    onRefreshStatus: () => void;

    onFilesChange2: (files: Array<File>) => void;
    onFilesError2: (error: Error, file: Array<File>) => void;
    onSelectFile: () => void;
    onSelectAllFile: () => void;

    orderDataDesign: DesignData[];
    orderDataTat: TatData[];
    orderDataMaterial: MaterialData[];
    orderDataManufacturer: ManufacturerData[];

    orderDataBranch: BranchData[];
    branchType: string;

    saveMaterialType: (event: string, index: number) => void;
    saveTatType: (event: string, index: number) => void;
    saveDesignType: (event: string, index: number) => void;
    saveMessegeOrder: (event: string, index: number) => void;
    saveManufactType: (event: string, index: number) => void;
    saveDesignSoftware: (event: string, index: number) => void;
    saveOrderModel: (event: string, index: number) => void;
    saveDesignApproval: () => void;
    saveIsBravo: () => void;

    saveBranchType: (branchType: string) => void;
    userDetails: UserDetail;

    saveBookingId: (event: string, index: number) => void;
    saveDrPreferences: (event: string, index: number) => void;

}

const escapeHtml = (value: string): string => {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
};
interface ExcelStyleMap {
    [className: string]: string;
}

const getExcelStyleMap = (
    doc: Document
): ExcelStyleMap => {
    const styleMap: ExcelStyleMap = {};

    const styleTags = doc.querySelectorAll('style');

    styleTags.forEach((styleTag) => {
        const css = styleTag.textContent || '';

        const matches =
            css.match(
                /\.[a-zA-Z0-9_-]+\s*\{[^}]*\}/g
            ) || [];

        matches.forEach((rule) => {
            const match = rule.match(
                /\.([a-zA-Z0-9_-]+)\s*\{([^}]*)\}/
            );

            if (!match) {
                return;
            }

            const className = match[1];
            const styles = match[2];

            styleMap[className] = styles;
        });
    });

    return styleMap;
};
interface RunStyle {
    bold?: boolean;
    italic?: boolean;
    underline?: boolean;
    color?: string;
    backgroundColor?: string;
    fontSize?: string;
    fontFamily?: string;
}

const getOwnStyle = (
    element: HTMLElement,
    styleMap: ExcelStyleMap
): RunStyle => {

    const className =
        element.getAttribute('class') || '';

    const excelStyle =
        styleMap[className] || '';

    const inlineStyle =
        element.getAttribute('style') || '';

    const combinedStyle =
        `${excelStyle};${inlineStyle}`;

    const result: RunStyle = {};

    if (
        /font-weight\s*:\s*(bold|[6-9]00)/i
            .test(combinedStyle)
    ) {
        result.bold = true;
    }

    if (
        /font-style\s*:\s*italic/i
            .test(combinedStyle)
    ) {
        result.italic = true;
    }

    if (
        /text-decoration\s*:[^;]*underline/i
            .test(combinedStyle)
    ) {
        result.underline = true;
    }

    const colorMatch =
        combinedStyle.match(
            /(?:^|;)color\s*:\s*([^;]+)/i
        );

    if (colorMatch) {
        result.color =
            colorMatch[1].trim();
    }

    const backgroundMatch =
        combinedStyle.match(
            /background(?:-color)?\s*:\s*([^;]+)/i
        );

    if (backgroundMatch) {
        result.backgroundColor =
            backgroundMatch[1].trim();
    }

    const fontSizeMatch =
        combinedStyle.match(
            /font-size\s*:\s*([^;]+)/i
        );

    if (fontSizeMatch) {
        result.fontSize =
            fontSizeMatch[1].trim();
    }

    const fontFamilyMatch =
        combinedStyle.match(
            /font-family\s*:\s*([^;]+)/i
        );

    if (fontFamilyMatch) {
        result.fontFamily =
            fontFamilyMatch[1].trim();
    }

    return result;
};
const normalizeExcelText = (text: string): string => {
    return text
        .replace(/\r\n/g, '\n')
        .replace(/\r/g, '\n')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n[ \t]+/g, '\n');
};
const renderInline = (
    node: Node,
    inherited: RunStyle,
    styleMap: ExcelStyleMap
): string => {

    if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || '';

        if (!text) {
            return '';
        }

        return escapeHtml(
            normalizeExcelText(text)
        );
    }

    if (!(node instanceof HTMLElement)) {
        return '';
    }

    if (node.tagName === 'BR') {
        return '<br>';
    }

    const ownStyle = getOwnStyle(
        node,
        styleMap
    );

    const merged: RunStyle = {
        ...inherited,
        ...ownStyle,
    };

    let content = '';

    node.childNodes.forEach((child) => {
        content += renderInline(
            child,
            merged,
            styleMap
        );
    });

    if (!content) {
        return '';
    }

    let formattedContent = content;

    if (merged.bold) {
        formattedContent =
            `<strong>${formattedContent}</strong>`;
    }

    if (merged.italic) {
        formattedContent =
            `<em>${formattedContent}</em>`;
    }

    if (merged.underline) {
        formattedContent =
            `<u>${formattedContent}</u>`;
    }

    const styles: string[] = [];

    if (merged.color) {
        styles.push(`color:${merged.color}`);
    }

    if (merged.backgroundColor) {
        styles.push(
            `background-color:${merged.backgroundColor}`
        );
    }

    if (merged.fontSize) {
        styles.push(
            `font-size:${merged.fontSize}`
        );
    }

    if (merged.fontFamily) {
        styles.push(
            `font-family:${merged.fontFamily}`
        );
    }

    if (styles.length > 0) {
        formattedContent =
            `<span style="${styles.join(';')}">${formattedContent}</span>`;
    }

    return formattedContent;
};
const convertExcelHtml = (
    html: string,
    plainText: string
): string => {

    const parser = new DOMParser();

    const doc =
        parser.parseFromString(
            html,
            'text/html'
        );

    const styleMap =
        getExcelStyleMap(doc);

    const cells =
        doc.querySelectorAll('td, th');

    let converted = '';

    cells.forEach((cell) => {

        const cellHtml =
            renderInline(
                cell,
                {},
                styleMap
            );

        if (!cellHtml.trim()) {
            return;
        }

        converted +=
            `<p>${cellHtml}</p>`;
    });

    if (!converted && plainText) {
        converted =
            `<p>${escapeHtml(plainText)}</p>`;
    }

    return converted;
};
const BorderLinearProgress = withStyles({
    root: {
        height: 8,
        backgroundColor: lighten('#3f51b5', 0.5),
    },
    bar: {
        borderRadius: 20,
        backgroundColor: '#3f51b5',
    },
})(LinearProgress);

const GreenCheckbox = withStyles({
    root: {
        color: green[400],
        '&$checked': {
            color: green[600],
        },
    },
    checked: {},
})((props: CheckboxProps) => <Checkbox size="small" color="default" {...props} />);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        tableBottom: {
            borderBottom: 'unset',
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        margin: {
            // margin: theme.spacing(1),
        },
        root1: {
            display: 'flex',
            height: '30vh',
            position: 'relative'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '3px solid #3f51b5',
                color: '#3f51b5'
            },
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'flex-end'
        },
         iconbuttons: {
            '& > *': {
                marginTop: '-50px',
            },            
        },
        filesize: {
            fontSize: '12px',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#3f51b5'
        },
        filesDropzoneActive: {
            border: '3px solid #3f51b5',
            color: '#3f51b5',
        },
        progressError: {
            fontSize: '0.7rem',
            color: '#D2222D'
        },
        progress: {
            fontSize: '0.7rem',
            color: '#FFBF00'
        },
        progressComp: {
            fontSize: '0.7rem',
            color: '#007000'
        },
        boxes: {
            display: 'flex',
            justifyContent: 'center',
        },
        update: {
            backgroundColor: '#fff',
            boxShadow: '1px 1px 5px 2px #aeaeae',
            padding: '15px',
            borderRadius: '2px'
        },
        tableHeadings: {
            fontSize: '0.9rem'
        },
        '& .MuiTableCell-sizeSmall': {
            padding: '6px 8px 6px 8px'
        },
        label: {
            display: 'block',
            fontSize: '0.8rem',
            fontWeight: 600,
            color: theme.palette.text.secondary,
            marginBottom: 6,
            textTransform: 'uppercase',
            letterSpacing: '0.03em',
        },
    })
);

const TableStyle = withStyles({
    root: {
        '& .MuiTableCell-sizeSmall': {
            padding: '6px 8px !important'
        }
    },
})(Table);

const FilesTableView: React.StatelessComponent<FilesTableViewProps> = (props) => {
    console.log('user-hey', props.userDetails);

    const classes = useStyles({});
    const inputLabel = React.useRef<HTMLLabelElement>(null);
    const [labelWidth, setLabelWidth] = React.useState(0);
    const quillRef = React.useRef<ReactQuill | null>(null);
    const [selectedValue, setSelectedValue] = React.useState<Array<string>>(Array(props.orderDataTat.length).fill(''));
    React.useEffect(() => {
        setLabelWidth(inputLabel.current!.offsetWidth);
    });
    console.log(props.progress, 'progress');
    React.useEffect(() => {

        const quill =
            quillRef.current?.getEditor();

        if (!quill) {
            return;
        }

        const editor =
            quill.root;

        const handlePaste = (
            event: ClipboardEvent
        ) => {

            const html =
                event.clipboardData
                    ?.getData('text/html') || '';

            const text =
                event.clipboardData
                    ?.getData('text/plain') || '';

            /*
            * Detect Excel HTML
            */

            const isExcel =
                html.includes('Microsoft Excel') ||
                html.includes(
                    'urn:schemas-microsoft-com:office:excel'
                ) ||
                html.includes('mso-') ||
                html.includes('Excel.Sheet');

            console.log(
                '[paste] isExcel:',
                isExcel
            );

            console.log(
                '[paste] HTML:',
                html
            );

            console.log(
                '[paste] TEXT:',
                text
            );

            /*
            * --------------------------------
            * 1. Excel HTML
            * --------------------------------
            */

            if (isExcel && html) {

                event.preventDefault();
                event.stopImmediatePropagation();

                const range =
                    quill.getSelection(true);

                if (!range) {
                    return;
                }

                const convertedHtml =
                    convertExcelHtml(
                        html,
                        text
                    );

                console.log(
                    '[paste] Excel converted:',
                    convertedHtml
                );

                quill.clipboard.dangerouslyPasteHTML(
                    range.index,
                    convertedHtml,
                    'user'
                );

                return;
            }

            /*
            * --------------------------------
            * 2. Excel partial selection
            *
            * Excel may give:
            *
            * HTML = ""
            * TEXT = "Lucky Thirteen Attack"
            *
            * We cannot recover the original
            * Excel formatting.
            * --------------------------------
            */

            if (!html && text) {

                /*
                * DO NOT intercept this.
                *
                * Let Quill handle normal
                * text / Word / browser paste.
                */

                return;
            }

            /*
            * --------------------------------
            * 3. Word / Browser HTML
            *
            * Let Quill handle it natively.
            * --------------------------------
            */

            return;
        };

        editor.addEventListener(
            'paste',
            handlePaste,
            true
        );

        return () => {

            editor.removeEventListener(
                'paste',
                handlePaste,
                true
            );

        };
    });
    return (
        <div className={classes.root}>
            {props.userDetails.dmeRequired !== '1' ?
                (
                    <div className={classes.boxes}>
                        <p className={classes.update}>Please update design preferences and material files by accessing the
                            Profile menu to choose desired turnaround time.
                        </p>
                    </div>
                ) :
                (
                    <></>
                )
            }
            <div className={classes.root1} >
                <Grid container justify="center" alignItems="center" >
                    <Grid item xs={12} sm={12} md={10}>
                        <div className="files">
                            <Files
                                className={classes.fileUpload}
                                onChange={props.onFilesChange2}
                                onError={props.onFilesError2}
                                accepts={['.zip']}
                                multiple
                                maxFiles={100}
                                maxFileSize={9200000000}
                                minFileSize={0}
                                clickable
                                dropActiveClassName={classes.filesDropzoneActive}
                            >
                                You can browse or Drag and drop files to create orders
                            </Files>
                        </div>
                    </Grid>
                </Grid>
            </div >
            <Grid container justify="space-between" alignItems="center" spacing={2}>
                <Grid item xs={6} sm={6} md={4}>
                    <FormControl variant="outlined" size="small" className={classes.forms}>
                        <InputLabel ref={inputLabel} htmlFor="outlined-age-simple" id="branch-division">Select Branch / Division</InputLabel>
                        <Select
                            labelId="branch-division"
                            id="branch-division"
                            onChange={(event) => props.saveBranchType(event.target.value as string)}
                            defaultValue="General"
                            value={props.branchType}
                            input={
                                <OutlinedInput
                                    labelWidth={labelWidth}
                                    name="age"
                                    id="outlined-age-simple"
                                />
                            }
                        >
                            {/* <MenuItem disabled value="General">
                                General
                            </MenuItem> */}
                            {props.orderDataBranch.length > 0 && props.orderDataBranch.map((branchType, index1) => (
                                <MenuItem id={branchType.rowno} value={branchType.sbu_name}>{branchType.sbu_name}</MenuItem>
                            ))}
                        </Select>
                        {/* <FormHelperText>Select Branch/ Division</FormHelperText> */}
                    </FormControl>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                    <div className={classes.iconbutton}>
                        {props.files2.length > 0 ?
                            <Button type="button" disabled={props.sending} variant="outlined" onClick={props.onUploadAllFiles} color="primary">Send</Button> :
                            <Button type="button" disabled variant="outlined" color="primary">Send</Button>}
                        {props.files2.length > 0 ?
                            <Button type="button" disabled={props.sending} variant="outlined" onClick={props.onClearAllFiles} color="secondary">Clear</Button> :
                            <Button type="button" disabled variant="outlined" color="secondary">Clear</Button>}
                        <Button type="button" variant="outlined" onClick={props.onClearAllUploaded} color="secondary">Clear Uploaded</Button>
                    </div>
                </Grid>
            </Grid>
            <CssBaseline />
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <TableContainer component={Paper}>
                        <TableStyle className={classes.table} size="small" stickyHeader aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">
                                        <Checkbox value={props.files2} id="selectAll" color="primary" onChange={props.onSelectAllFile} />
                                    </TableCell>

                                    {/* <TableCell align="center" id="fileUpl1" className={classes.tableHeadings}>Material</TableCell>
                                    <TableCell align="center" id="fileUpl1" className={classes.tableHeadings}>Design&nbsp;Type</TableCell> */}
                                    <TableCell align="center" id="fileUpl2" className={classes.tableHeadings}>Turn-Around Time</TableCell>
                                    <TableCell align="center" id="fileUpl3" className={classes.tableHeadings}>Destination</TableCell>
                                    <TableCell align="center" id="fileUpl4" className={classes.tableHeadings}>Design Software</TableCell>
                                    <TableCell align="center" id="fileUpl5" className={classes.tableHeadings}>Model</TableCell>
                                    {/* <TableCell align="center" id="fileUp20" className={classes.tableHeadings}>Booking ID</TableCell> */}
                                    <TableCell align="center" id="fileUpl6" className={classes.tableHeadings}>Design Approval</TableCell>
                                    <TableCell align="center" id="fileUpl7" className={classes.tableHeadings} />
                                    {/* <TableCell align="center" id="fileUpl6" className={classes.tableHeadings}>Bravo / Premium</TableCell> */}
                                    <TableCell align="center" id="fileUpl8" />
                                </TableRow>
                                {/* <TableRow>
                                    <TableCell align="center" id="fileUpl1" className={classes.tableHeadings}>File&nbsp;Name</TableCell>
                                    <TableCell align="center" id="fileUpl7" className={classes.tableHeadings}>Message</TableCell>
                                </TableRow> */}
                            </TableHead>
                            <TableBody>
                                {Array.isArray(props.files2) && props.files2.length > 0 && props.files2.map((file, index) => (

                                    <React.Fragment key={index}>
                                        <TableRow>
                                            <TableCell rowSpan={2}>
                                                <Checkbox
                                                    size="small"
                                                    color="primary"
                                                    id={(JSON.parse(JSON.stringify(file)).id)}
                                                    value={index}
                                                    checked={JSON.parse(JSON.stringify(file)).selected === true ? true : false}
                                                    onChange={props.onSelectFile}
                                                />
                                            </TableCell>
                                            {/* <TableCell align="left">{++index}</TableCell> */}

                                            {/* <TableCell align="left">
                                            <FormControl variant="outlined" size="small" className={classes.forms}>
                                                <Select
                                                    labelId="demo-simple-select-outlined-label"
                                                    id="demo-simple-select-outlined"
                                                    required
                                                    onChange={(event) => props.saveMaterialType(event.target.value as string, index as number)}
                                                >
                                                    <MenuItem disabled value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {props.orderDataMaterial.map((mattyp, index1) => (
                                                        <MenuItem id={mattyp.rowno} value={mattyp.materialname}>{mattyp.materialname}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </TableCell>
                                        <TableCell align="left">
                                            <FormControl variant="outlined" size="small" className={classes.forms}>
                                                <Select
                                                    labelId="demo-simple-select-outlined-label"
                                                    id="demo-simple-select-outlined"
                                                    required
                                                    onChange={(event) => props.saveDesignType(event.target.value as string, index as number)}
                                                >
                                                    <MenuItem  disabled value="">
                                                        <em>None</em>
                                                    </MenuItem>
                                                    {props.orderDataDesign.map((desigtyp, index1) => (
                                                        <MenuItem id={desigtyp.rowno} value={desigtyp.dtype}>{desigtyp.dtype}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </TableCell> */}
                                            <TableCell align="left" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControl margin="dense" variant="outlined" size="small" className={classes.forms}>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            fullWidth
                                                            required
                                                            onChange={(event) => {
                                                                const newValue = event.target.value as string;
                                                                const newSelectedValues = [...selectedValue];
                                                                newSelectedValues[index] = newValue;
                                                                setSelectedValue(newSelectedValues);
                                                                props.saveTatType(event.target.value as string, index as number);
                                                            }}
                                                            value={props.userDetails.dmeRequired === '1' ?
                                                                // If dmeRequired is 1, set the value to the selected value or an empty string if tat is undefined
                                                                (JSON.parse(JSON.stringify(file)).tat !== undefined ? JSON.parse(JSON.stringify(file)).tat : '') :
                                                                // If dmeRequired is not 1, set the value to an empty string
                                                                selectedValue[index] || ''
                                                            }
                                                        >
                                                            <MenuItem disabled value="">
                                                                <em>Turn Around Time</em>
                                                            </MenuItem>
                                                            {Array.isArray(props.orderDataTat) && props.orderDataTat.length > 0 && props.orderDataTat.map((tatime, index1) => (
                                                                props.userDetails.dmeRequired === '1' ?
                                                                    (
                                                                        <MenuItem key={tatime.rowno} value={tatime.tattype}>{tatime.tattype}</MenuItem>
                                                                    )
                                                                    :
                                                                    (
                                                                        <MenuItem key={tatime.rowno} value={tatime.tattype} disabled={(tatime.tattype !== 'Next Day') && (tatime.tattype !== 'Next Day 7 AM')}>{tatime.tattype}</MenuItem>
                                                                    )
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                            <TableCell align="left" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControl margin="dense" variant="outlined" size="small" className={classes.forms}>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            required
                                                            fullWidth
                                                            onChange={(event) => props.saveManufactType(event.target.value as string, index as number)}
                                                            value={JSON.parse(JSON.stringify(file)).manufactType !== undefined ? JSON.parse(JSON.stringify(file)).manufactType : ''}
                                                        >
                                                            <MenuItem disabled value="">
                                                                <em>Destination</em>
                                                            </MenuItem>
                                                            <MenuItem value="In-House">
                                                                In-House
                                                            </MenuItem>
                                                            {Array.isArray(props.orderDataManufacturer) && props.orderDataManufacturer.length > 0 && props.orderDataManufacturer.map((manufactType) => (
                                                                <MenuItem id={manufactType.rowno} value={manufactType.dest}>{manufactType.dest}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                            <TableCell align="left" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControl margin="dense" variant="outlined" size="small" className={classes.forms}>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label"
                                                            id="demo-simple-select-outlined"
                                                            required
                                                            fullWidth
                                                            onChange={(event) => props.saveDesignSoftware(event.target.value as string, index as number)}
                                                            value={JSON.parse(JSON.stringify(file)).designSoftware !== undefined ? JSON.parse(JSON.stringify(file)).designSoftware : ''}
                                                        >
                                                            <MenuItem disabled value="">
                                                                <em>Design Software</em>
                                                            </MenuItem>
                                                            <MenuItem value="Exocad">
                                                                Exocad
                                                            </MenuItem>
                                                            <MenuItem value="3Shape">
                                                                3Shape
                                                            </MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                            <TableCell align="left" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControl margin="dense" variant="outlined" size="small" className={classes.forms}>
                                                        <Select
                                                            labelId="demo-simple-select-outlined-label-model"
                                                            id="demo-simple-select-outlined-model"
                                                            required
                                                            fullWidth
                                                            onChange={(event) => props.saveOrderModel(event.target.value as string, index as number)}
                                                            value={JSON.parse(JSON.stringify(file)).model !== undefined ? JSON.parse(JSON.stringify(file)).model : ''}
                                                        >
                                                            <MenuItem value="Y">
                                                                Y
                                                            </MenuItem>
                                                            <MenuItem value="N">
                                                                N
                                                            </MenuItem>
                                                            <MenuItem value="S">
                                                                Only Model
                                                            </MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                            {/* <TableCell
                                                align="left"
                                                className={classes.tableBottom}
                                            >
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControl
                                                        margin="dense"
                                                        variant="outlined"
                                                        size="small"
                                                        className={classes.forms}
                                                    >
                                                        <TextField
                                                            variant="outlined"
                                                            label="booking ID"
                                                            // multiline
                                                            fullWidth
                                                            size="small"
                                                            inputProps={{ maxLength: 100 }}
                                                            onChange={(event) => {
                                                                let value = event.target.value;

                                                                // Allow only alphanumeric and spaces, plus newlines (\n for multiline)
                                                                value = value.replace(/[^a-zA-Z0-9 \n]/g, '');
                                                                props.saveBookingId(
                                                                value,
                                                                index
                                                                );
                                                            }}
                                                            value={JSON.parse(JSON.stringify(file)).bookingId}
                                                        />
                                                    </FormControl>
                                                </div>
                                            </TableCell> */}
                                            <TableCell align="center" className={classes.tableBottom}>
                                                <div style={{ fontSize: '0.7rem' }}>
                                                    <FormControlLabel
                                                        control={
                                                            <GreenCheckbox
                                                                checked={JSON.parse(JSON.stringify(file)).approval === true ? true : false}
                                                                value={index}
                                                                onChange={props.saveDesignApproval}
                                                                name="DesignApproval"
                                                            />
                                                        }
                                                        label="Required"
                                                    />
                                                </div>
                                            </TableCell>
                                            <TableCell align="center" rowSpan={2}>
                                                <IconButton
                                                    size="small"
                                                    onClick={props.deleteRowbyId}
                                                    id={JSON.parse(JSON.stringify(file)).id}
                                                    value={JSON.parse(JSON.stringify(file)).filename}
                                                    color="primary"
                                                    aria-label="delete"
                                                    className={classes.iconbuttons}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            {/* <TableCell /> */}
                                            <TableCell component="th" scope="row" colSpan={2}>
                                                <div style={{ wordBreak: 'break-word' }}>
                                                    <span style={{ fontWeight: 900 }}>FILE NAME : </span>
                                                    {`${JSON.parse(JSON.stringify(file)).filename} - (${JSON.parse(JSON.stringify(file)).sizeReadable})`}
                                                    {(Array.isArray(props.progress) && props.progress.length > 0 && props.progress[index] > 0 && JSON.parse(JSON.stringify(file)).uploaded === 'uploading') ?
                                                        <div className={classes.progress}>Upload In-Progress</div>
                                                        : (
                                                            JSON.parse(JSON.stringify(file)).uploaded === false
                                                            &&
                                                            <div className={classes.progressError}>Upload error
                                                                {JSON.parse(JSON.stringify(file)).errorReason && ` - ${JSON.parse(JSON.stringify(file)).errorReason}`}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                                {Array.isArray(props.progress) && props.progress.length > 0 && props.progress[index] > 0 ?
                                                    <BorderLinearProgress
                                                        className={classes.margin}
                                                        variant="determinate"
                                                        value={props.progress[index]}

                                                    />
                                                    : null}
                                                {Array.isArray(props.progress) && props.progress.length > 0 && props.progress[index] === 100
                                                    && JSON.parse(JSON.stringify(file)).uploaded === true
                                                    && <div className={classes.progressComp}>File uploaded</div>
                                                }

                                            </TableCell>
                                             <TableCell align="left">
                                                <div style={{ display: 'grid', gap: '10px', marginTop: '-8px', fontSize: '0.7rem' }}>
                                                    {/* Bravo / Premium Checkbox */}
                                                    <FormControlLabel
                                                        control={
                                                            <GreenCheckbox
                                                                checked={JSON.parse(JSON.stringify(file)).bravopremium === true}
                                                                value={index}
                                                                onChange={props.saveIsBravo}
                                                                name="Bravo/Premium"
                                                            />
                                                        }
                                                        label="Bravo / Premium"
                                                    />

                                                    {/* Message Field */}
                                                    <FormControl
                                                        variant="outlined"
                                                        size="small"
                                                        className={classes.forms}
                                                        style={{ flex: 1 }}
                                                    >
                                                    <TextField
                                                        variant="outlined"
                                                        label="Message"
                                                        // multiline
                                                        fullWidth
                                                        size="small"
                                                        onChange={(event) =>
                                                        props.saveMessegeOrder(event.target.value, index)
                                                        }
                                                        value={JSON.parse(JSON.stringify(file)).msg !== undefined ? JSON.parse(JSON.stringify(file)).msg : ''}
                                                    />
                                                    </FormControl>
                                                </div>
                                             </TableCell>

                                            <TableCell
                                                align="left"
                                                // className={classes.tableBottom}
                                                colSpan={3}
                                            >
                                                <div style={{ fontSize: '0.7rem' }}>
                                                {/* <FormControl
                                                    margin="dense"
                                                    variant="outlined"
                                                    size="small"
                                                    className={classes.forms}
                                                >                                          
                                                    <TextField
                                                        variant="outlined"
                                                        label="Dr Preferencesrr"
                                                        multiline
                                                        rows={3}
                                                        fullWidth
                                                        size="small"
                                                        inputProps={{ maxLength: 3000 }}
                                                        value={JSON.parse(JSON.stringify(file)).drPreferences || ''}
                                                        onChange={(event) => {
                                                            let value = event.target.value;

                                                            // Allow only alphanumeric and spaces, plus newlines (\n for multiline)
                                                            // value = value.replace(/[^a-zA-Z0-9 \n]/g, '');

                                                            // Enforce 3000-character limit
                                                            if (value.length > 3000) {
                                                            value = value.slice(0, 3000);
                                                            }

                                                            props.saveDrPreferences(value, index);
                                                        }}
                                                    />
                                                </FormControl> */}
                                                    <FormControl
                                                        margin="dense"
                                                        variant="outlined"
                                                        size="small"
                                                        className={classes.forms}
                                                    >
                                                        <label className={classes.label}>
                                                            Preferences
                                                        </label>

                                                        <ReactQuill
                                                            ref={quillRef}
                                                            theme="snow"
                                                            value={JSON.parse(JSON.stringify(file)).drPreferences || ''}
                                                            onChange={(value) => {
                                                                props.saveDrPreferences(value, index);
                                                            }}
                                                            modules={{
                                                                toolbar: [
                                                                    ['bold', 'italic', 'underline'],
                                                                    [{ color: [] }, { background: [] }],
                                                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                                                    ['link'],
                                                                    ['clean'],
                                                                ],
                                                            }}
                                                        />
                                                    </FormControl>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </TableStyle>
                    </TableContainer>
                </Grid>
            </Grid>
        </div>
    );
};

export default FilesTableView;



// WEBPACK FOOTER //
// ./src/components/layouts/FilesTableView.tsx